import type { ReactNode } from 'react';

/**
 * Editorial labels in the DM Mono metadata role (blueprint §2 —
 * docs/redesign/DESIGN_BLUEPRINT.md): kickers mark the section a screen is
 * in ("Make a memory / Place it"), tiny labels mark learning metadata.
 * Never use these for body copy or controls.
 */
export function SectionKicker({ children }: { children: ReactNode }) {
  return <p className="rd-section-kicker">{children}</p>;
}

export function TinyLabel({ children }: { children: ReactNode }) {
  return <p className="rd-tiny-label">{children}</p>;
}
